// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

type Doc = {
  activeElement: HTMLElement,
};

export default class FormView extends JQueryView {
  planType: string;
  autoClicked: boolean;
  doc: Doc;

  constructor(planType: string) {
    super('.new_company_member_form');
    this.planType = planType;
    this.autoClicked = true;
    // $FlowFixMe
    this.doc = (document: Doc);
    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  // プロフェッショナルプラン以外は権限関連の操作をした場合にプランモーダルを表示する
  @on({
    event: 'mousedown',
    selector: '#permissions',
  })
  onClickPermissionRadios(event: Event) {
    if (!this.planTypeIsProfessional()) {
      $('#plan_modal').modal();
      event.preventDefault();
    }
  }

  @on({ event: 'change', selector: '#email' })
  onChangeFormControl(event: Event) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
    this.updateBasic();
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: Event) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
    }
  }

  @on({
    event: 'click',
    selector: '#all_write',
  })
  onClickAllWrite() {
    $('select.form-control.select').filter((i, element) => {
      const write = Array.from(element.options).filter(
        option => option.value === 'write',
      )[0];
      write.selected = true;
    });

    $('div.subject-key').filter((i, element) => {
      $(element).addClass('d-none');
    });
  }

  @on({
    event: 'click',
    selector: '#all_read',
  })
  onClickAllRead() {
    $('select.form-control.select').filter((i, element) => {
      if (
        [
          // コーポレート手続き
          'company_member_form_permissions_attributes_7_permission',
          // 提携サービス
          'company_member_form_permissions_attributes_9_permission',
        ].includes(element.id)
      ) {
        // 閲覧可が存在しない権限は編集可とする
        const write = Array.from(element.options).filter(
          option => option.value === 'write',
        )[0];
        write.selected = true;
      } else {
        const read = Array.from(element.options).filter(
          option => option.value === 'read',
        )[0];
        read.selected = true;
      }

      $('div.subject-key').filter((i, element) => {
        $(element).addClass('d-none');
      });
    });
  }

  @on({
    event: 'click',
    selector: '#all_access_deny',
  })
  onClickAllAccessDeny() {
    $('select.form-control.select').filter((i, element) => {
      if (
        // 会社情報は閲覧不可が存在しないため、1つ上の閲覧可にする
        element.id === 'company_member_form_permissions_attributes_1_permission'
      ) {
        const read = Array.from(element.options).filter(
          option => option.value === 'read',
        )[0];
        read.selected = true;
      } else {
        const access_deny = Array.from(element.options).filter(
          option => option.value === 'access_deny',
        )[0];
        access_deny.selected = true;
      }
    });

    $('div.subject-key').filter((i, element) => {
      $(element).addClass('d-none');
    });
  }

  @on({ event: 'change', selector: '#permissions' })
  onChangePermission(event: any) {
    const target = event.target;
    const options = target.options;
    const selectedIndex = options.selectedIndex;
    const subjectElementId = '#' + target.id + '_subject';

    if (options[selectedIndex].value === 'individual') {
      $(subjectElementId).removeClass('d-none');
    } else {
      $(subjectElementId).addClass('d-none');
    }
  }

  updateBasic() {
    $('#basic_button').click();
  }

  planTypeIsProfessional() {
    return this.planType === 'professional';
  }
}
